"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _wrapNativeSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/wrapNativeSuper"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AggregateError = exports.CustomAggregateError = exports.AbortError = exports.zip = exports.wait = exports.parseContentRange = exports.toArrayRecursively = exports.toArray = exports.times = exports.range = exports.invert = exports.forEach = exports.endsWith = exports.chunk = exports.assign = void 0;

function assign(target, source) {
  for (var key in source) {
    if (source.hasOwnProperty(key)) {
      target[key] = source[key];
    }
  }
}

exports.assign = assign;

function chunk(iterable, length) {
  var results = [];
  var lengthOfIterable = iterable.length;

  for (var i = 0; i < lengthOfIterable; i += length) {
    var chunked = [];

    for (var ci = i; ci < i + length; ci++) {
      chunked.push(iterable[ci]);
    }

    results.push(chunked);
  }

  return results;
}

exports.chunk = chunk;

function endsWith(string, expectedEnding) {
  if (string.length < expectedEnding.length) {
    return false;
  }

  var actualEnding = string.substr(string.length - expectedEnding.length);
  return actualEnding === expectedEnding;
}

exports.endsWith = endsWith;

function forEach(iterable, func) {
  var length = iterable.length;

  for (var i = 0; i < length; i++) {
    func(iterable[i], i);
  }
}

exports.forEach = forEach;

function invert(oldObj) {
  var newObj = {};

  for (var key in oldObj) {
    if (oldObj.hasOwnProperty(key)) {
      var value = oldObj[key];
      newObj[value] = key;
    }
  }

  return newObj;
}

exports.invert = invert;

function range(n) {
  var results = [];

  for (var i = 0; i < n; i++) {
    results.push(i);
  }

  return results;
}

exports.range = range;

function times(numTimes, func) {
  var results = [];

  for (var i = 0; i < numTimes; i++) {
    results.push(func(i));
  }

  return results;
}

exports.times = times;

function toArray(iterable) {
  var results = [];
  var length = iterable.length;

  for (var i = 0; i < length; i++) {
    results.push(iterable[i]);
  }

  return results;
}

exports.toArray = toArray;

function toArrayRecursively(input) {
  if (input.length) {
    return toArray(input).map(toArrayRecursively);
  }

  return input;
}

exports.toArrayRecursively = toArrayRecursively; // copied from https://github.com/academia-de-codigo/parse-content-range-header/blob/master/index.js

function parseContentRange(headerValue) {
  if (!headerValue) {
    return null;
  }

  if (typeof headerValue !== 'string') {
    throw new Error('invalid argument');
  }

  var parseInt = function parseInt(number) {
    return Number.parseInt(number, 10);
  }; // Check for presence of unit


  var matches = headerValue.match(/^(\w*) /);
  var unit = matches && matches[1]; // check for start-end/size header format

  matches = headerValue.match(/(\d+)-(\d+)\/(\d+|\*)/);

  if (matches) {
    return {
      unit: unit,
      first: parseInt(matches[1]),
      last: parseInt(matches[2]),
      length: matches[3] === '*' ? null : parseInt(matches[3])
    };
  } // check for size header format


  matches = headerValue.match(/(\d+|\*)/);

  if (matches) {
    return {
      unit: unit,
      first: null,
      last: null,
      length: matches[1] === '*' ? null : parseInt(matches[1])
    };
  }

  return null;
}

exports.parseContentRange = parseContentRange;
/*
 * Promisified wrapper around 'setTimeout' to allow 'await'
 */

function wait(_x) {
  return _wait.apply(this, arguments);
}

function _wait() {
  _wait = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(milliseconds) {
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new Promise(function (resolve) {
              return setTimeout(resolve, milliseconds);
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _wait.apply(this, arguments);
}

exports.wait = wait;

function zip(a, b) {
  var A = Array.isArray(a) ? a : Array.from(a);
  var B = Array.isArray(b) ? b : Array.from(b);
  return A.map(function (k, i) {
    return [k, B[i]];
  });
}

exports.zip = zip; // Based on https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error

var AbortError = /*#__PURE__*/function (_Error) {
  (0, _inherits2.default)(AbortError, _Error);

  var _super = _createSuper(AbortError);

  function AbortError(params) {
    var _this;

    (0, _classCallCheck2.default)(this, AbortError);
    // Pass remaining arguments (including vendor specific ones) to parent constructor
    _this = _super.call(this, params); // Maintains proper stack trace for where our error was thrown (only available on V8)

    if (Error.captureStackTrace) {
      Error.captureStackTrace((0, _assertThisInitialized2.default)(_this), AbortError);
    }

    _this.name = 'AbortError';
    return _this;
  }

  return (0, _createClass2.default)(AbortError);
}( /*#__PURE__*/(0, _wrapNativeSuper2.default)(Error));

exports.AbortError = AbortError;

var CustomAggregateError = /*#__PURE__*/function (_Error2) {
  (0, _inherits2.default)(CustomAggregateError, _Error2);

  var _super2 = _createSuper(CustomAggregateError);

  function CustomAggregateError(errors, message) {
    var _this2;

    (0, _classCallCheck2.default)(this, CustomAggregateError);
    _this2 = _super2.call(this, message);
    _this2.errors = errors;
    _this2.message = message;
    _this2.name = 'AggregateError';
    return _this2;
  }

  return (0, _createClass2.default)(CustomAggregateError);
}( /*#__PURE__*/(0, _wrapNativeSuper2.default)(Error));

exports.CustomAggregateError = CustomAggregateError;
exports.AggregateError = CustomAggregateError;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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